export const resetStyles = `

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
`;

export const staticStyles = `

form.form div label {
  font-family: var(--field-label-font-family);
  font-size: var(--field-label-font-size);
  font-weight: var(--field-label-font-weight);
  margin-bottom: var(--field-label-bottom-spacing);
  padding: var(--field-label-padding);
  color: var(--field-label-color);
}

/* Label and input layout */
.field-wrapper {
  display: flex;
flex-direction: var(--field-label-alignment);
}

form.form div.form-field {
  padding-top: var(--field-top-spacing);
}

form.form div.form-field .field-label {
  flex-basis: var(--field-label-width);
  flex-shrink: 0;
  // margin: auto 0;
}

form.form div.form-field .text {
  flex-basis: var(--field-input-width);
  flex-grow: 1;
}

form.form input.text::placeholder,
form.form input.date::placeholder,
form.form textarea::placeholder {
  color: var(--placeholder-color);
  transition: var(--transition-main);
  font-size: var(--placeholder-font-size);
  font-weight: var(--placeholder-font-weight);
  font-family: var(--placeholder-font-weight);
}

/* input field */
form.form input.text {
  height: var(--input-height);
  width: var(--input-width) !important;
  border-width: var(--input-border-width);
  border-color: var(--input-border-color);
  border-style: var(--input-border-style);
  border-bottom: solid var(--input-border-color) var(--input-border-width);
  padding: 0 var(--input-padding);
  color: var(--input-color);
  font-size: var(--input-font-size);
  font-family: var(--input-font-family);
  border-radius: var(--input-border-radius);
  transition: var(--transition-main);
  background-color: var(--input-background-color);
}

form.form input.text:active,
form.form input.text:focus,
form.form input.text:hover,
form.form input.date:active,
form.form input.date:focus,
form.form input.date:hover {
  background-color: var(--input-hover-background-color);
  border-width: var(--input-hover-border-width);
  border-color: var(--input-hover-border-color);
  outline: none !important;
}

/* select field */
form.form select {
  height: var(--select-height);
  width: var(--select-width) !important;
  border-width: var(--select-border-width);
  border-color: var(--select-border-color);
  border-style: var(--select-border-style);
  border-bottom: solid var(--select-border-color) var(--select-border-width);
  padding: 0 var(--select-padding);
  color: var(--select-color);
  font-size: var(--select-font-size);
  font-family: var(--select-font-family);
  border-radius: var(--select-border-radius);
  transition: var(--transition-main);
  background-color: var(--select-background-color);
  background: var(--select-background-color) var(--select-background-image) no-repeat right var(--select-background-image-position-right) center;
  background-size: var(--select-background-image-size);
  appearance: var(--select-appearance);

}

form.form select:active,
form.form select:focus,
form.form select:hover {
  background-color: var(--select-hover-background-color);
  border-width: var(--select-hover-border-width);
  border-color: var(--select-hover-border-color);
  outline: none !important;
}

/* text area field */
form.form textarea {

  width: var(--textarea-width) !important;
  border-width: var(--textarea-border-width);
  border-color: var(--textarea-border-color);
  border-style: var(--textarea-border-style);
  border-bottom: solid var(--textarea-border-color) var(--textarea-border-width);
  padding: 5px var(--textarea-padding) !important;
  color: var(--textarea-color);
  font-size: var(--textarea-font-size);
  font-family: var(--textarea-font-family);
  border-radius: var(--textarea-border-radius);
  transition: var(--transition-main);
  background-color: var(--textarea-background-color);
}

form.form textarea.standard {
  height: var(--textarea-height);
}

form.form textarea:active,
form.form textarea:focus,
form.form textarea:hover {
  background-color: var(--textarea-hover-background-color);
  border-width: var(--textarea-hover-border-width);
  border-color: var(--textarea-hover-border-color);
  outline: none !important;
}

form.form p.error.no-label {
  font-size: var(--error-text-font-size);
  font-family: var(--error-text-font-family);
  font-weight: var(--error-text-font-weight);
  color: var(--error-text-color);
  margin-top: var(--error-text-top-spacing);
  padding: 0 var(--error-text-padding);
}

.red-background, form.form p.errors {
  font-size: var(--error-heading-font-size);
  font-family: var(--error-heading-font-family);
  font-weight: var(--error-heading-font-weight);
  color: var(--error-heading-color);
  margin: 0 0 var(--error-heading-bottom-spacing);
  padding: var(--error-heading-padding);
  background: var(--error-heading-bg-color); 
}

span.description {
  font-family: var(--description-font-family);
  font-size: var(--description-font-size);
  font-weight: var(--description-font-weight);
  color: var(--description-color);
  margin-top: var(--description-top-spacing);
  padding: var(--description-padding);
  display: block;
}

form.form p.submit {
  margin: 0;
  padding: 0;
  text-align: var(--submit-alignment);
  margin-left: 0 !important;
}

input[type="submit"] {
  background-color: var(--submit-background);
  color: var(--submit-color);
  margin-top: var(--submit-margin-top) !important;
  height: var(--submit-height);
  width: var(--submit-width);
  border-style: solid;
  border-color: var(--submit-border-color);
  border-width: var(--submit-border-width);
  transition: var(--transition-main);
  font-size: var(--submit-font-size);
  font-family: var(--submit-font-family);
  border-radius: var(--submit-border-radius);
  cursor: pointer;
  text-align: var(--submit-text-align);
  font-weight: var(--submit-font-weight) !important;
  background: var(--submit-background) var(--submit-background-image) no-repeat right var(--submit-background-image-position-right) center;
  background-size: var(--submit-background-image-size);
}

input[type="submit"]:hover,
input[type="submit"]:active {
  color: var(--submit-color-hover);
  background-color: var(--submit-background-hover);
  border-color: var(--submit-border-color-hover);
  border-width: var(--submit-border-width);
}

/* checkbox and radio button */

/* hide the regular checkbox */
#pardot-form .pd-checkbox input,
#pardot-form .pd-radio input {
  opacity: 0;
  position: absolute;
}

#pardot-form .pd-checkbox input,
#pardot-form .pd-checkbox label, 
#pardot-form .pd-radio input,
#pardot-form .pd-checkbox label {
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
  cursor: pointer;
}

/* position the label */
#pardot-form .pd-checkbox label,
#pardot-form .pd-radio label {
  display: flex !important;
  position: relative;
  margin-left: 0px !important;
  align-items: center;
}

/* style the unchecked checkbox & radio */
#pardot-form .pd-checkbox input + label:before,
#pardot-form .pd-radio input + label:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  padding: 0px;
  margin-right: 6px;
  border-style: solid;
}

#pardot-form .pd-checkbox input + label:before {
  width: var(--checkbox-input-size);
  min-width: var(--checkbox-input-size);
  height: var(--checkbox-input-size);
  border-color: var(--checkbox-unchecked-border-color);
  border-width: var(--checkbox-border-width);
  background: var(--checkbox-unchecked-background);
  font-size: var(--checkbox-input-size);
  line-height: var(--checkbox-input-size);
  border-radius: var(--checkbox-border-radius);
}
#pardot-form .pd-radio input + label:before {
  width: var(--radio-input-size);
  min-width: var(--radio-input-size);
  height: var(--radio-input-size);
  border-color: var(--radio-unchecked-border-color);
  border-width: var(--radio-border-width);
  background: var(--radio-unchecked-background);
  border-radius: var(--radio-border-radius);
}

/* style the checked checkbox */
#pardot-form .pd-checkbox input:checked + label:before {
  content: var(--checkbox-checked-content);
  background: var(--checkbox-checked-background);
  color: var(--checkbox-checked-color);
  border-color: var(--checkbox-checked-border-color);
}

/* style the checked radio */
#pardot-form .pd-radio input:checked + label:before {
  content: "";
  background: var(--radio-checked-background);
  color: var(--radio-checked-color);
  border-color: var(--radio-checked-border-color);
}

/* Remove default Checkboxes and Radio Buttons margin-left */
form.form span.value {
  margin-left: 0;
}
/* Checkboxes and Radio Buttons alignment, stacked or horizontal */
form.form .pd-checkbox .value span, 
form.form .pd-radio .value span {
  float: var(--checkbox-alignment);
  margin-right: 20px;
  position: relative;
}
form.form .pd-radio .value span {
  float: var(--radio-alignment);
  margin-right: 20px;
  margin-top: 4px;
}

/* checkbox label.inline styling */
.pd-checkbox label.inline {
  font-family: var(--checkbox-label-font-family);
  font-size: var(--checkbox-label-font-size);
  font-weight: var(--checkbox-label-font-weight);
  color: var(--checkbox-label-color);
}

/* radio button label.inline styling */
.pd-radio label.inline {
  font-family: var(--radio-label-font-family);
  font-size: var(--radio-label-font-size);
  font-weight: var(--radio-label-font-weight);
  color: var(--radio-label-color);
}

/* Toggle custom styling BEGIN */
/* Removing the custom checkbox/radio styling */
#pardot-form .custom-toggle input + label:before {
  display: none !important;
}

/* Toggle styling */
form.form .custom-toggle input[type="checkbox"],
form.form .custom-toggle input[type="radio"] {
    padding: 0;
    position: var(--toggle-position) !important; /* relative to left align, absolute for right align */
    right: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: var(--toggle-width);
    min-width: var(--toggle-width);
    height: var(--toggle-height);
    background-color: var(--toggle-background-color);
    border: var(--toggle-border-width) solid var(--toggle-border-color);
    box-sizing: content-box;
    border-radius: var(--toggle-border-radius);
    transition: all .25s;
    margin-right: var(--toggle-margin-right) !important;
}

/* This is for right align toggle */
form.form .custom-toggle .value span {
    display: flex;
}

/* Toggle knob styling */
form.form .custom-toggle input[type="checkbox"]:after, 
form.form .custom-toggle input[type="radio"]:after {
    content: '';
    width: var(--toggle-knob-width);
    height: var(--toggle-knob-height);
    background-color: var(--toggle-knob-color);
    display: block;
    position: absolute;
    left: var(--toggle-knob-alignment);
    top: 50%;
    transform: translate(0,-50%);
    -webkit-transform: translate(0,-50%);
    border-radius: 50%;
    transition: all .25s;
}

form.form .custom-toggle input[type="checkbox"]:checked,
form.form .custom-toggle input[type="radio"]:checked {
  background-color: var(--toggle-checked-background-color);
}

form.form .custom-toggle input[type="checkbox"]:checked:after, 
form.form .custom-toggle input[type="radio"]:checked:after {
    background-color: var(--toggle-knob-checked-color);
    left: calc(100% - var(--toggle-knob-width) - var(--toggle-knob-alignment));
    transform: translate(0,-50%);
    -webkit-transform: translate(0,-50%);
}

/* Ensure toggle input is visible for interaction */
#pardot-form .custom-toggle input, 
#pardot-form .custom-toggle input {
    opacity: 1 !important;
}

form.form .custom-toggle .value span {
    margin-bottom: var(--toggle-margin-bottom);
}

/* this is for right align toggle */
form.form .custom-toggle .value span {
    display: flex;
}

/* Toggle label.inline styling */
.custom-toggle label.inline {
  font-family: var(--toggle-label-font-family);
  font-size: var(--toggle-label-font-size);
  font-weight: var(--toggle-label-font-weight);
  color: var(--toggle-label-color);
}

/* Toggle custom styling END */


/* columns styling */

/* 2-columns styling */
body form.form div.form-col-1 {
  float: left !important;
  clear: left !important;
  width: 49% !important;
}
body form.form div.form-col-2 {
  float: right !important;
  clear: right !important;
  width: 49% !important;
}
body form.form div.form-col-full {
  width: 100%;
  clear: both;
}

/* Errors */
.red-color, form.form div.error, form.form p.error, form.form p.error label, form.form span.error {
  color: var;
  padding: 5px 0;
}

form.form div p.no-label {
  margin-left: 0;
}


/* reCAPTCHA */
form.form .pd-captcha {
    position: relative !important;
    width: 304px !important;
    left: 0 !important;
    display: block !important;
    top: 20px;
}

 /*Responsive adjustments for reCAPTCHA */
  @media screen and (max-width: 479px) {
    form.form .pd-captcha {
      position: relative !important;
      width: 100% !important; 
    }

    .g-recaptcha {
      transform: scale(0.77);
      -webkit-transform: scale(0.77);
      transform-origin: 0 0;
      -webkit-transform-origin: 0 0;
    }
    
}

/* mobile columns styling */
@media screen and (max-width: 479px) {
  body form.form div.form-col-1,
  body form.form div.form-col-2 {
    width: 100% !important;
    float: unset !important;
    clear: both !important;
  }
}
   
    `;


export const htmlCode = `

<form accept-charset="UTF-8" method="post" action="%%form-action-url%%" class="form" id="pardot-form">
%%form-opening-general-content%%
%%form-if-thank-you%%
	%%form-javascript-focus%%
	%%form-thank-you-content%%
	%%form-thank-you-code%%
%%form-end-if-thank-you%%
%%form-if-display-form%%
	%%form-before-form-content%%
		%%form-if-error%%
			<p class="errors">Please correct the errors below:</p>
		%%form-end-if-error%%
		%%form-start-loop-fields%%
			<div class="form-field %%form-field-css-classes%% %%form-field-class-type%% %%form-field-class-required%% %%form-field-class-hidden%% %%form-field-class-no-label%% %%form-field-class-error%% %%form-field-dependency-css%%">
			<div class="field-wrapper">
				%%form-if-field-label%%
					<label class="field-label" for="%%form-field-id%%">%%form-field-label%%</label>
				%%form-end-if-field-label%%
				%%form-field-input%%
			</div>
				%%form-if-field-description%%
					<span class="description">%%form-field-description%%</span>
				%%form-end-if-field-description%%
			<div id="error_for_%%form-field-id%%" style="display:none"></div>
			%%form-field-if-error%%
				<p class="error no-label">%%form-field-error-message%%</p>
			%%form-field-end-if-error%%
		    </div>
		%%form-end-loop-fields%%
		%%form-spam-trap-field%%
		<!-- forces IE5-8 to correctly submit UTF8 content  -->
		<input name="_utf8" type="hidden" value="&#9731;" />
		<p class="submit">
			<input type="submit" accesskey="s" value="%%form-submit-button-text%%" %%form-submit-disabled%%/>
		</p>
	%%form-after-form-content%%
%%form-end-if-display-form%%
%%form-javascript-link-target-top%%
</form>

<!--This script changes the color of the required asterisk-->
<script>
	var all = document.getElementsByClassName('field-label');
	for (var i = 0; i < all.length; i++) {
		var $oldReq = all[i].innerHTML;
		console.log($oldReq);
		var $newReq = '<span style="color:var(--field-label-color-asterisk)!important;">*</span>';
		$oldReq = $oldReq.replace(" *", $newReq);
		all[i].innerHTML = $oldReq
	}
</script>
`